import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';
import { Form } from 'react-bootstrap';
import { Button, Container, IconButton } from '@mui/material';
import Select from "react-select";
import { baseURL } from '../base_url';
import axios from 'axios';
import moment from 'moment';
// import AlertMaps from './AlertMaps';
import { PuffLoader } from 'react-spinners';
import { read, utils, writeFile } from 'xlsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import CommentIcon from '@mui/icons-material/Comment';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosConfig';

const FleetLogs = () => {
    const navigate = useNavigate();
    const [accessDetails, setAccessDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [exportTableData ,setExportTableData] = useState([]);
    const [selectedFromDate, setSelectedFromDate] = useState(new Date(new Date().setDate(new Date().getDate() - 2)));
    const [selectedToDate, setSelectedToDate] = useState(new Date());

    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const authToken = foundUser['auth_token'];

    const data = {
        columns: [
          {
            label: 'S.No',
            field: 'id',
          },
          {
            label: 'User Name',
            field: 'user_name',
          },
          {
            label: 'Uploaded Datetime(EST)',
            field: 'uploaded_datetime_est',
          },
          {
            label: 'Uploaded Datetime(UTC)',
            field: 'uploaded_datetime',
          },
          {
            label: 'Fleet Records',
            field: 'fleet_count',
          }
        ],
        rows: accessDetails
    };

    const handleExportTableData = () => {
        const headings = [['S.No','User Name','Uploaded Datetime(EST)','Uploaded Datetime(UTC)','Fleet Record']];
        const sampleVin = exportTableData;
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, sampleVin, { origin: 'A2', skipHeader: true });
        utils.book_append_sheet(wb, ws, 'Fleet Logs');
        writeFile(wb, 'Fleet Logs.xlsx');
    }

    useEffect(() => {
      alertData();
    },[])

    const submitDate = () => {
      alertData();
    }

    const alertData = () => {
      setLoading(true);
      axiosInstance.get(baseURL + "/get_fleet_upload_audit?from="+selectedFromDate.toISOString()+"&to="+selectedToDate.toISOString()
      ).then((res) => {
          var j = 1;
          if(res.data.status === '1'){
            let rowsData = [];
            let ExportTableData = [];
            const myDataSet = res.data.data;
            for (var index = 0; index < res.data.data.length; index++) {
              let rowItem = {};
              const val = myDataSet[index];
              const est_datetime = moment(new Date(val.uploaded_datetime)).tz("US/Eastern").format('MM/DD/YYYY hh:mm A')
              rowItem["id"] = j;
              rowItem["user_name"] = val.user_name;
              rowItem["uploaded_datetime_est"] = moment(new Date(val.uploaded_datetime)).tz("US/Eastern").format('MM/DD/YYYY hh:mm A');
              rowItem["uploaded_datetime"] = val.uploaded_datetime
              rowItem["fleet_count"] = val.fleet_count;
              rowsData.push(rowItem)
              ExportTableData.push([j, val.user_name,rowItem["uploaded_datetime_est"], val.uploaded_datetime, val.fleet_count])
              j++;
            }
            setExportTableData(ExportTableData)
            setAccessDetails(rowsData);
          }else{
            setAccessDetails([]);
          }
          setLoading(false);
      })
    }
  
    return (
    <div className='body_class' style={{marginLeft:"13vw",paddingLeft:"20px",paddingRight:"20px"}}>
        <h5>Fleet Logs</h5>
        <div className='row p-4'>
          <div className="col-auto mt-1">
            <label htmlFor="datepicker" className="form-label">Start Date:</label>
          </div>
          <div className='col-2'>
            <DatePicker
              id="datepicker"
              selected={selectedFromDate}
              onChange={(date) => setSelectedFromDate(date)}
              className="form-control" // Bootstrap class for input fields
            />
          </div>
          <div className="col-auto mt-1">
            <label htmlFor="datepicker" className="form-label">To Date:</label>
          </div>
          <div className='col-2'>
            <DatePicker
              id="datepicker"
              selected={selectedToDate}
              onChange={(date) => setSelectedToDate(date)}
              className="form-control" // Bootstrap class for input fields
            />
          </div>
          {/* <div className='col-5'></div> */}
          <div className='col-2'>
            <Button variant="contained" onClick={submitDate} >Submit</Button>
          </div>
        </div>
        <div style={{ position: "absolute", marginTop:"-5px", padding:"7px"}}><Button size='small' variant="contained" onClick={handleExportTableData}>Export Excel</Button></div>
        <div className="row mt-1">
            {/* {!detailsOpen && */}
            {/* <div className="col-md-1"></div> */}
            <div className="col-md-8">
                <MDBDataTable
                    bordered
                    data={data}
                    large={false}
                    displayEntries={false}
                    search={true}
                    noBottomColumns={true}
                    className="pagination-right-aligned"
                    searching={true}
                />
            </div>
            {/* } */}
        </div>
    </div>
    );
};

export default FleetLogs;
